import { VStack, Box, Col, Row } from "@reverb-ui/react";
import { IconVariationEnum } from "data/constants/constants";
import { panelsInfo } from "helper/panelsHelper";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext } from "react";
import { MetricCard } from "../../components/MetricCard";
import { CampaignSummaryContext } from "../context-api/CampaignSummaryProvider";
import PanelContainer from "presentation/components/PanelContainer";

const campaignSummaryInfo = panelsInfo.campaignSummary;

export const CampaignSummaryReports = () => {
  const {
    requestParamsIndex,
    campaignSummaryData,
    downloadCampaignSummaryReport,
    downloadingReports,
    isLoading,
  } = useContext(CampaignSummaryContext);

  return (
    <PanelContainer
      panelId={campaignSummaryInfo.htmlId}
      panelName={campaignSummaryInfo.description}
      rangeName={campaignSummaryData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadCampaignSummaryReport,
        downloadingReports: downloadingReports,
        panelInfo: campaignSummaryInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col
          col={!isLoading && campaignSummaryData?.cards.length === 0 ? 0 : 3}
        >
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={2}
              spacingBetween={5}
              hasSubText={true}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {campaignSummaryData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  subDescription={item.subText}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={!isLoading && campaignSummaryData?.cards.length === 0 ? 12 : 9}
        >
          <Box
            bg="white"
            w="full"
            p={6}
            height={400}
            overflow="auto"
            className="sortedTable"
          >
            {isLoading ? (
              <SortedTableSkeleton numberOfColumns={6} />
            ) : (
              <SortedTable
                dataColumns={campaignSummaryData?.summary.dataColumns || []}
                dataRows={campaignSummaryData?.summary.dataRows || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
